import { makeStyles } from '@material-ui/core/styles';

const EventsStyles =
    makeStyles((theme) => ({
        summaryGridPadding: {
            //marginTop: "32px !important",
        },
        header: {
            textAlign: "center",
            padding: "40px 0px",
        },
        subtitle: {
            fontSize: "15px",
        }
    }));

export default EventsStyles;
